<div class="payment-sip-upi-intents">
  <div *ngFor="let item of (config?.paymentOptions?.options?.TOPRECURRINGUPI || config?.paymentOptions?.options?.TOPUPI) | keyvalue" class="upi-intents" [ngClass]="{'d-none': (config?.paymentOptions?.options?.TOPRECURRINGUPI && !item?.value?.recurring)}">
    <div class="m-10" (click)="submit(item)">
      <span class="pIcon" [ngClass]="item.key" matRipple></span>
      <span class="b-name">{{item?.value?.name || item?.value}}</span>
    </div>
  </div>
</div>